/* global fbq */
/* global Konduto */

import axios from 'axios'
import store from '@/store'
import router from '@/router'
export default {

  async getSessionToken () {
    let sessionToken = localStorage.getItem('session_token')
    if (sessionToken) {
      return sessionToken
    } else {
      await this.logout()
      router.push({path: '/login'})
      return false
    }
  },

  async acceptPush (accept) {
    let response = await axios.put(store.getters.getOpaApi + '/user/' + store.getters.getUser.ID + '/' + store.getters.getCompanyId, {
     action: accept
    })
    return response
  },

  isLoggedIn () {
    let user = localStorage.getItem('userLogin')
    let sessionToken = localStorage.getItem('session_token')
    if (user && sessionToken) {
      return true
    } else {
      return false
    }
  },

  async doLogin (email, password) {
    // save last typed email to use if auto validation redirect
    localStorage.setItem('tryValidationEmail', email)
    try {
      let result = await axios.put(store.getters.getOpaApi + '/user/login', {
        companyId: store.getters.getCompanyId,
        email: email.trim(),
        password: password
      })

      console.log(result)

      this.updateLocalUser(result.data)
      await this.updateUserInfo()

      // if compnay needs to block by address
      if (store.state.company.block_address_navigation && store.state.company.block_address_navigation !== 'NO') {
        //if user is locked and have an address temp
        if (store.state.tempAddress.street && store.state.tempAddress.number) {
          console.log('user addresses', store.state.user.adresses)
          let addrs = store.state.user.adresses.filter((a) => a.name === store.state.tempAddress.street && a.streetNumber === store.state.tempAddress.number)
          let addr = null
          if (addrs.length) {
            console.log('GOT PREVIOUS ADDRESS', addrs, addrs[0])
            addr = addrs[0]
          } else {
            console.log('GO TO SAVE ADDRESS')
            let resultSaveAddr = await this.saveAddress(store.state.user.id,
              store.state.tempAddress.street,
              store.state.tempAddress.number,
              store.state.tempAddress.more,
              store.state.tempAddress.vicinity,
              store.state.tempAddress.city,
              store.state.tempAddress.state,
              store.state.tempAddress.country,
              store.state.tempAddress.cep,
              store.state.tempAddress.latLong)
            if (!resultSaveAddr.error){
              console.log('CREATE NEW ADDRESS')
              addr = store.state.user.adresses[store.state.user.adresses.length -1]
            } else {
              console.log(resultSaveAddr)
              console.log('UNEXPECTED ERROR ADD ADDR')
              //location.reload()
            }
          }
          if (addr) {
            console.log('SET ADDR', addr)
            store.state.selectedAddressShort = addr.shortName
            store.state.lastLatLongUri = addr.latLong.lat + '/' + addr.latLong.lng
            store.state.selectedAddressId = addr.id
          } else {
            console.log('UNEXPECTED ERROR ADDR NOT FOUND')
          }
        } else {
          console.log('UNEXPECTED LOGIN NOT TEMP ADDRESS', store.state.tempAddress)
        }
      }



      return result.data
    } catch (e) {
      let error = {e}
      return {error: error.e.exception.msg}
    }
  },

  async logout (noReload) {
    await localStorage.removeItem('userLogin')
    await localStorage.removeItem('user')
    await localStorage.removeItem('session_token')
    localStorage.removeItem('pushUserId')
    if (!noReload) {
      location.reload()
    } else {
      router.push({path:'/home'})
    }
    return true
  },

  async register (name, familyName, email, phone, cpf, gender, password, birthday) {
    try {
      localStorage.setItem('tryValidationEmail', email)
      let result = await axios.post(store.getters.getOpaApi + '/user/userPublic/' + store.getters.getCompanyId, {
        name: name.trim(),
        familyName: familyName,
        email: email.trim(),
        phone: phone,
        cpf: cpf,
        gender: gender,
        password: password,
        birthday: birthday,
        domain: store.state.company.Id
      })
      localStorage.setItem('user', JSON.stringify(result.data))
      store.state.user = result.data
      if (store.state.facebookPixel) {
        fbq('track', 'CompleteRegistration', {
          content_name: 'register',
          status: true,
        })
      }
      localStorage.setItem('tempMail', email.trim())
      localStorage.setItem('tempPass', password)
      return {data: result.data}
    } catch (e) {
      let error = {e}
      console.log(error.e.msg)
      let msg = 'Error ao registrar usuário'
      if (error.e.msg === 'user already exists') {
        msg = 'Usuário já existente'
      }
      // return {error: error.e.msg}
      return {error: msg}

    }
  },

  async resendValidationCode () {
    try {
      let email = localStorage.getItem('tryValidationEmail')
      if (email) {
        let result = await axios.get(store.getters.getOpaApi +
          '/user/validationCode/' + email.trim() + '/' + store.getters.getCompanyId + '/' + store.state.company.Id)
        return result.data
      } else {
        return ({error: true, msg: 'Erro ao reenviar código'})
      }
    } catch (e) {
      let error = {e}
      let msg = 'Erro ao reenviar código'
      if (error.e.msg &&  error.e.msg === 'user not found') {
        msg = 'Usuário não encontrado'
      }
      return ({error: true, msg: msg})
    }
  },

  async verifyRegister (code) {
    let email = localStorage.getItem('tryValidationEmail')
    if (!email) {
      return ({error: true, msg: 'Erro ao verificar código'})
    }
    let companyId = store.getters.getCompanyId
    try {
      let result = await axios.put(store.getters.getOpaApi + '/user/verify/' + email,
      {
        code: code,
        companyId: companyId
      })
      if (store.state.facebookPixel) {
        fbq('track', 'CompleteRegistration', {
          content_name: 'verify_register',
          status: true,
        })
      }
      return result.data
    } catch (e) {
      console.log(e)
      // TODO error message to this endpoint
      return ({error: true, msg: 'Erro ao verificar código'})
    }
  },

  async changePass (password, code, userId) {
    try {
      let result = await axios.put(store.getters.getOpaApi + '/user/changePasswordByCode', {
        code: Number(code),
        password: password,
        userId: userId,
        companyId: store.getters.getCompanyId
      })
      return result.data
    } catch (e) {
      let error = {e}
      return { error: true, obj: error}
    }
  },

  async saveAddress (userId, name, streetNumber, more, vicinity, city, state, country, cep, latLong) {
    try {
      let result = await axios.post(store.getters.getOpaApi + '/user/address/' + userId + '/' + store.getters.getCompanyId, {
        name: name.trim(),
        streetNumber: streetNumber,
        more: more,
        vicinity: vicinity,
        city: city,
        state: state,
        country: country,
        cep: cep,
        latLong: latLong
      })
      if (result.data) {
        this.updateLocalUser(result.data)
        return result.data
      } else {
        return {error: true, msg: 'Erro ao salvar endereço'}
      }
    } catch (e) {
      let error = {e}
      return {error: true, obj:error, msg: 'Erro ao salvar endereço'}
    }
  },

  async removeAddress (id) {
    let userId = store.state.user.id
    try {
      let result = await axios.delete(store.getters.getOpaApi + '/user/address/' + userId + '/' + store.getters.getCompanyId + '/' + id)
      if (result.data) {
        this.updateLocalUser(result.data)
        return result.data
      } else {
        return {error: true, msg: 'Erro ao remover endereço'}
      }
    } catch (e) {
      let error = {e}
      return {error: true, obj:error, msg: 'Erro ao remover endereço'}
    }
  },

  async saveCard (userId, flag, number, name, goodTrhu, cpf) {
    try {
      let result = await axios.post(store.getters.getOpaApi + '/user/card/' + userId + '/' + store.getters.getCompanyId, {
        flag: flag,
        number: number,
        name: name,
        goodTrhu: goodTrhu,
        cpf: cpf
      })
      if (result.data) {
        this.updateLocalUser(result.data)
        return result.data
      }
    } catch (e) {
      let error = {e}
      console.log(error.e.msg)
      let msg = 'Erro ao salvar cartão'
      if (error.e.msg === 'card already exists') {
        msg = 'Cartão já existente'
      }
      return { error: true, obj:error, msg: msg}
    }
  },

  async removeCard (id) {
    let userId = store.state.user.id
    try {
      let result = await axios.delete(store.getters.getOpaApi + '/user/card/' + userId + '/' + store.getters.getCompanyId + '/' + id)
      if (result.data) {
        this.updateLocalUser(result.data)
        return result.data
      } else {
        return {error: true, msg: 'Erro ao remover cartão'}
      }
    } catch (e) {
      let error = {e}
      return {error: true, obj:error, msg: 'Erro ao remover cartão'}
    }
  },

  updateLocalUser (remoteUser) {
    let user = JSON.stringify(remoteUser)
    localStorage.setItem('userLogin', user)
    localStorage.setItem('user', user)
    if (remoteUser.token) {
      localStorage.setItem('session_token', remoteUser.token)
    }
    store.state.user = remoteUser
  },

  async updatePushId () {
    console.log('update push id')
    let localUser = localStorage.getItem('user')
    let oneSignalUserId = localStorage.getItem('pushUserId')

    console.log('user push data', oneSignalUserId)

    if (localUser && localUser !== 'null' && oneSignalUserId && oneSignalUserId !== 'null') {
      localUser = JSON.parse(localUser)
      try {
        let result = await axios.put(store.getters.getOpaApi + '/user/' + localUser.id + '/onesignal-id', {
          company_id: store.getters.getCompanyId,
          onesingnal_id: oneSignalUserId
        })
        console.log('updated push id ')
        console.log(localUser.id)
        console.log(oneSignalUserId)
        if (result.data){
          return true
        } else {
          return false
        }
      } catch (e) {
        let error = {e}
        console.log(e, error)
        return false
      }
    }
  },

  async updateUserInfo () {
    console.log('update user info')
    await this.updatePushId()
    this.sendUserIdKonduto()
  },

   sendUserIdKonduto() {
    let localUser = localStorage.getItem('user')
     let company = store.getters.getCompany
     if (localUser && company && company.konduto && company.konduto.public_key) {
       localUser = JSON.parse(localUser)
       var customerID = localUser.id; // define o ID do cliente
       (function() {
         var period = 60000;
         var limit = 20 * 1e3;
         var nTry = 0;
         var intervalID = setInterval(function() { // loop para retentar o envio
           var clear = limit/period <= ++nTry;
           if ((typeof(Konduto) !== "undefined") &&
             (typeof(Konduto.setCustomerID) !== "undefined")) {
             window.Konduto.setCustomerID(customerID); // envia o ID para a Konduto
             clear = true;
           }
           if (clear) {
             clearInterval(intervalID);
           }
         }, period);
       })(customerID);
     }

  }

}
